import React from 'react';
import IconeSobrescrito from './IconeSobrescrito';
import { Update } from '@mui/icons-material';

interface IPropsIconeReportVotoFuturo {
}


export default class IconeReportVotoFuturo extends React.Component<IPropsIconeReportVotoFuturo> {


    render() {
        return (
            <IconeSobrescrito>
                <Update />
            </IconeSobrescrito>
        );
    }
}
